import { useAppProductionWarning } from './useAppProductionWarning';

export const ProductionWarningProvider = ({ children }) => {
  useAppProductionWarning();

  return children;
};
